import React from "react";
import SettingMenu from "./SettingMenu";
import { Navigate, Route, Routes } from "react-router-dom";
import Category from "../category/Category";
import Products from "../Products/Products";
import Customer from "../customer/Customer";
import { ThemeBasedColorMenubar } from "src/shared/modules/profile/theme/themeCheacker";
import UOM from "../uom/UOM";
import Employee from "../employee/Employee";
import SettingConfiguration from "../settingConfiguration/SettingConfiguration";
import NotFound from "src/shared/modules/admin/NotFound";
import PermissionRoute, { hasPermission } from "src/shared/components/PermissionRoute";
import { useUser } from "src/business-types/grocery/components/UserContext";
import { reactAppVersion } from "src/features/auth/axiosConfig";

function SettingNavigation() {
  const { user } = useUser();

  const permissions = (user?.permissions || {}) as Record<string, string[]>;

  /* ---------------- ROUTE CONFIG ---------------- */
  const adminRoutes = [
    { path: `/grocery/${reactAppVersion}/admin/products`, permission: "product_view" },
    { path: `/grocery/${reactAppVersion}/admin/categories`, permission: "category_view" },
    { path: `/grocery/${reactAppVersion}/admin/customers`, permission: "customer_view" },
    { path: `/grocery/${reactAppVersion}/admin/UOM`, permission: "product_view" },
    { path: `/grocery/${reactAppVersion}/admin/employees`, permission: "user_view" },
    { path: `/grocery/${reactAppVersion}/admin/configurations`, permission: "setting_view" },
  ];

  /* ---------------- FIND FIRST ALLOWED ---------------- */
  const firstAllowedRoute = adminRoutes.find((r) =>
    hasPermission(permissions, r.permission)
  )?.path;

  return (
    <div className='w-full h-full flex flex-col overflow-hidden'>
      <SettingMenu />

      <div
        className={`w-auto h-[87%] flex my-1 mr-5 mx-2 border border-gray-200 rounded-2xl shadow-inner ${ThemeBasedColorMenubar()}`}
      >
        <Routes>
          {/* ✅ Dynamic Redirect */}
          <Route
            path='/'
            element={
              firstAllowedRoute ? (
                <Navigate to={firstAllowedRoute} replace />
              ) : (
                <Navigate to={`/grocery/${reactAppVersion}/admin/products`} replace />
              )
            }
          />

          {/* ✅ Products */}
          <Route
            path='/products'
            element={
              <PermissionRoute permission='product_view'>
                <Products />
              </PermissionRoute>
            }
          />

          {/* ✅ Categories */}
          <Route
            path='/categories'
            element={
              <PermissionRoute permission='category_view'>
                <Category />
              </PermissionRoute>
            }
          />

          {/* ✅ Customers */}
          <Route
            path='/customers'
            element={
              <PermissionRoute permission='customer_view'>
                <Customer />
              </PermissionRoute>
            }
          />

          {/* ✅ UOM */}
          <Route
            path='/UOM'
            element={
              <PermissionRoute permission='product_view'>
                <UOM />
              </PermissionRoute>
            }
          />

          {/* ✅ Employees */}
          <Route
            path='/employees'
            element={
              <PermissionRoute permission='user_view'>
                <Employee />
              </PermissionRoute>
            }
          />

          {/* ✅ Configurations */}
          <Route
            path='/configurations'
            element={
              <PermissionRoute permission='setting_view'>
                <SettingConfiguration />
              </PermissionRoute>
            }
          />

          {/* ❌ Not Found */}
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
    </div>
  );
}

export default SettingNavigation;